import { MapTileConfig } from '@mobile-mapping/web3d';
import { Accessor, createContext, createMemo, JSX, useContext } from 'solid-js';

const MapTileConfigContext = createContext<Accessor<MapTileConfig>>();

export interface MapTileConfigProviderProps extends MapTileConfig {
  readonly children: JSX.Element;
}

export function MapTileConfigProvider(
  props: MapTileConfigProviderProps
): JSX.Element {
  const config = createMemo<MapTileConfig>(() => ({
    mapTileServiceBaseUrl: props.mapTileServiceBaseUrl,
    mapTileLayerQueryParams: props.mapTileLayerQueryParams,
    mapTileAuthToken: props.mapTileAuthToken,
  }));

  return (
    <MapTileConfigContext.Provider value={config}>
      {props.children}
    </MapTileConfigContext.Provider>
  );
}

export function useMapTileConfig(): MapTileConfig {
  const context = useContext(MapTileConfigContext);
  if (context === undefined) {
    throw new Error(
      'useMapTileConfig must be used within a MapTileConfigProvider'
    );
  }
  return context();
}
